// extracted by mini-css-extract-plugin
export var aboutAuthorWrapper = "blogsStyles-module--aboutAuthorWrapper--VAGel";
export var bottomContentWrapper = "blogsStyles-module--bottomContentWrapper--EWyhG";
export var cards = "blogsStyles-module--cards--pkdZc";
export var cardsWrapper = "blogsStyles-module--cardsWrapper--g1L0l";
export var csImageText = "blogsStyles-module--csImageText--qK-O1";
export var heroImg = "blogsStyles-module--heroImg--btpbY";
export var mainContentWrapper = "blogsStyles-module--mainContentWrapper--e+Gn0";
export var onePostBlock = "blogsStyles-module--onePostBlock--RUrha";
export var richText = "blogsStyles-module--richText--swY7q";
export var stickyContent = "blogsStyles-module--stickyContent--AlOZK";